import { Extension } from '@tiptap/core'
import Table from '@tiptap/extension-table'
import TableRow from '@tiptap/extension-table-row'
import TableCell from '@tiptap/extension-table-cell'
import TableHeader from '@tiptap/extension-table-header'

// Configure the Table extension with all required table functionality
export const RichTable = Extension.create({
  name: 'richTable',
  
  addExtensions() {
    return [
      // Main Table extension with configurations
      Table.configure({
        resizable: true,
        allowTableNodeSelection: true,
        HTMLAttributes: {
          class: 'rich-table',
        },
      }),
      
      // Table Row extension
      TableRow,
      
      // Table Cell extension with background color support
      TableCell.configure({
        HTMLAttributes: {
          class: 'table-cell',
        },
      }),
      
      // Table Header extension
      TableHeader,
    ]
  },
})

// Table utility functions
export const insertTable = (editor, options = { rows: 3, cols: 3, withHeaderRow: true }) => {
  if (!editor) return false
  return editor.chain().focus().insertTable(options).run()
}

// Add new function to set table cell background color
export const setTableCellBackground = (editor, color) => {
  if (!editor) return false
  
  // Get the current selection
  const { from, to } = editor.state.selection
  
  // Find the table cell node at the current position
  const pos = editor.state.selection.$anchor.pos
  const node = editor.state.doc.nodeAt(pos)
  
  if (node && node.type.name === 'tableCell') {
    // Apply the color directly to the current cell
    return editor.chain().focus().updateAttributes('tableCell', { 
      style: `background-color: ${color}` 
    }).run()
  }
  
  return false
}

// Add new function to get current table cell background color
export const getTableCellBackground = (editor) => {
  if (!editor) return null
  
  // Get the current position
  const pos = editor.state.selection.$anchor.pos
  const node = editor.state.doc.nodeAt(pos)
  
  if (node && node.type.name === 'tableCell') {
    // Extract the background color from the style attribute
    const style = node.attrs.style || ''
    const match = style.match(/background-color:\s*([^;]+)/)
    return match ? match[1] : null
  }
  
  return null
}

export const addColumnBefore = (editor) => {
  if (!editor) return false
  return editor.chain().focus().addColumnBefore().run()
}

export const addColumnAfter = (editor) => {
  if (!editor) return false
  return editor.chain().focus().addColumnAfter().run()
}

export const deleteColumn = (editor) => {
  if (!editor) return false
  return editor.chain().focus().deleteColumn().run()
}

export const addRowBefore = (editor) => {
  if (!editor) return false
  return editor.chain().focus().addRowBefore().run()
}

export const addRowAfter = (editor) => {
  if (!editor) return false
  return editor.chain().focus().addRowAfter().run()
}

export const deleteRow = (editor) => {
  if (!editor) return false
  return editor.chain().focus().deleteRow().run()
}

export const deleteTable = (editor) => {
  if (!editor) return false
  return editor.chain().focus().deleteTable().run()
}

export const mergeCells = (editor) => {
  if (!editor) return false
  return editor.chain().focus().mergeCells().run()
}

export const splitCell = (editor) => {
  if (!editor) return false
  return editor.chain().focus().splitCell().run()
}

export const toggleHeaderColumn = (editor) => {
  if (!editor) return false
  return editor.chain().focus().toggleHeaderColumn().run()
}

export const toggleHeaderRow = (editor) => {
  if (!editor) return false
  return editor.chain().focus().toggleHeaderRow().run()
}

export const toggleHeaderCell = (editor) => {
  if (!editor) return false
  return editor.chain().focus().toggleHeaderCell().run()
}